import React from 'react';
import PropTypes from 'prop-types';
import { OrderSummaryGiftCheckbox } from '../../order-summary-gift-checkbox';

import style from './style.module.css';

const GiftCheckboxComponent = ({ salesOrderId }) => {
  return (
    <div className={style['order-summary-gift-details']}>
      <OrderSummaryGiftCheckbox salesOrderId={salesOrderId} />
    </div>
  );
};

export const GiftCheckbox = React.memo(GiftCheckboxComponent);

GiftCheckbox.propTypes = {
  salesOrderId: PropTypes.string.isRequired,
};
